(function ($, Global) {
    var MessagesComponent = function () {
        this.selector = 'body > .messages';
        this.itemSelector = '.message-item';
        this.$el = $(this.selector);
        this.liveChatSelector = '#chat-widget-container';
    };

    MessagesComponent.prototype.initEvents = function () {
        this.publishers();       
    };

    MessagesComponent.prototype.publishers = function () {
        var self = this;
        $(document).ready(function () {
            setTimeout(self.resizeItemsWhenLiveChatExist.bind(self), 800);
        });
        $(Global).smartResize(self.resizeItemsWhenLiveChatExist.bind(self), 600);
    };

    MessagesComponent.prototype.resizeItemsWhenLiveChatExist = function () {
        var self = this;

        if (!$(self.liveChatSelector).exists()) return;

        var margin;
        var liveChatWidth = $(self.liveChatSelector).outerWidth();       
        var windowWidth = $('body').innerWidth();
        var messageContainerWidth = self.$el.find('.container').outerWidth();
        var spaceBetweenMessageItemAndWindow = Math.floor((windowWidth - messageContainerWidth) / 2);

        if (spaceBetweenMessageItemAndWindow > liveChatWidth) {
            margin = 0;
        } else {
            margin = liveChatWidth - spaceBetweenMessageItemAndWindow;   
        }

        self.$el.find('.container').css('padding-right', margin);
    };

    Global.MessagesComponent = MessagesComponent;
}(jQuery, window));